import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Flag } from "lucide-react";
import { useAuth, formatApiError } from "../context/AuthContext";
import { PrimaryBtn, Field, Input } from "../components/kit";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };

  const DEMO_EMAIL = "wm962xjt2d@privaterelay.appleid.com";
  const DEMO_PASSWORD = "GolfPro2026!";
  const loginDemo = async () => {
    setEmail(DEMO_EMAIL);
    setPassword(DEMO_PASSWORD);
    setBusy(true);
    try {
      await login(DEMO_EMAIL, DEMO_PASSWORD);
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Demo login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-10 justify-center">
          <Flag className="text-[#CCFF00]" size={28} />
          <span className="font-heading text-3xl">PAR<span className="text-[#CCFF00]">PREP</span></span>
        </div>
        <div className="border border-[#262626] bg-[#141414] p-8">
          <h1 className="font-heading text-2xl uppercase mb-1">Welcome back</h1>
          <p className="text-sm text-[#A3A3A3] mb-6">Log in to your training program.</p>
          <form onSubmit={submit} className="space-y-5">
            <Field label="Email">
              <Input data-testid="login-email" type="email" value={email} required
                onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" />
            </Field>
            <Field label="Password">
              <Input data-testid="login-password" type="password" value={password} required
                onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </Field>
            <PrimaryBtn data-testid="login-submit" type="submit" disabled={busy} className="w-full">
              {busy ? "Signing in…" : "Log In"}
            </PrimaryBtn>
          </form>
          <button onClick={loginDemo} disabled={busy} data-testid="demo-fill"
            className="mt-4 w-full border border-[#262626] py-3 text-xs font-bold uppercase tracking-wide text-[#CCFF00] hover:border-[#CCFF00] transition-colors disabled:opacity-40">
            {busy ? "Logging in…" : "Log in with demo account (one tap)"}
          </button>
          <p className="mt-6 text-sm text-[#A3A3A3] text-center">
            No account? <Link to="/register" className="text-[#CCFF00] hover:underline">Create one</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
